import React from 'react'
import Header from './components/Header'
import MainContent from './components/MainContent'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <MainContent />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App 